module.exports = __webpack_public_path__ + "media/images/icon__checkmark--rb-dark-gray@2x-74c7ed59a9ed6191372025e54ba90753.png";